<template>
    <div>
        <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="doQueryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

        <!--<div class="base-search-container mb10">-->
            <!--<swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="doQueryHandler"></swb-query-sort-area>-->
        <!--</div>-->
        <!--<div class="table-layout">-->
            <!--<el-table :data="merchtGoodsUknoList" border ref="tableList" style="width: 100%" @selection-change="handleSelectionChange">-->
                <!--<el-table-column align="center" width="230" prop="no" label="商品标识码" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column align="center" width="80" prop="postFlag" label="是否补码" show-overflow-tooltip>-->
                    <!--<template slot-scope="scope">-->
                        <!--<span v-if="scope.row.postFlag">是</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="center" width="100" prop="manualFlag" label="是否人工编码" show-overflow-tooltip>-->
                    <!--<template slot-scope="scope">-->
                        <!--<span v-if="scope.row.manualFlag">是</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="center" width="80" prop="retailerComId" label="是否使用" show-overflow-tooltip>-->
                    <!--<template slot-scope="scope">-->
                        <!--<span class="font-red" v-if="scope.row.retailerComId == null">未使用</span>-->
                        <!--<span class="font-green" v-if="scope.row.retailerComId != null">已使用</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="left" prop="retailerInnerNo" label="买家内部编码" width="250" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column align="center" width="150" prop="creatorName" label="操作人" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column align="center" width="150" prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column align="center" width="80" prop="retailerId" label="是否有效" show-overflow-tooltip>-->
                    <!--<template slot-scope="scope">-->
                        <!--<span class="font-red" v-if="scope.row.invalid">已作废</span>-->
                        <!--<span class="font-green" v-if="!scope.row.invalid">正常</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            <!--</el-table>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, Routes, MsgBox,DomSizeWatcher } from '../../app.vues'
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    //
    import { getDefaultPageSizes } from '../../app.conf'
    import goodsDelivApi from '../../api/goodsDeliv'
    //
    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "商品标识码",
            "code": "no",
            "valueType": "String",
            "basic": true
        }]
    };
    //
    export default {
        name: 'swb-mercht-goods-uk-no-shop-voucher-list',
        avlActions: '',
        avlScopes: 'mercht',
        desc: '商品标识码列表',
        props: {
            itemId: {
                type: Number,
            },
            voucherId: {
                type: Number,
            },
        },
        data: function () {
            return {
                confKey: "swb-mercht-goods-uk-no-shop-voucher-list",
                queryOnLoad: true,
                tableHeight: 500,
                needPager: false, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                merchtGoodsUknoList: [],
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                }
            }
        },
        created: function () {
            let self = this;
            //
            this.queryConfig = Utils.merge({}, searchConfigData);

            this.getMerchtGoodsUknoList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            this.initResultTable();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            // 数据列表
            initResultTable(){
                let self = this;
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(this.querySortArea);
//                resultTable.setColConfRef(this.querySortArea);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'retailerComId': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = "";
                        if(row.retailerComId == null){
                            domHtml = '<span class="font-red">未使用</span>';
                        }else{
                            domHtml = '<span class="font-green">已使用</span>';
                        }
                        return domHtml;
                    },
                    'invalid': function (row, colName, colValue, rowIndex, colConf) {
                       let domHtml = "";
                       if(row.invalid){
                           domHtml = '<span class="font-red">已作废</span>';
                       }else{
                           domHtml = '<span class="font-green">正常</span>';
                       }
                       return domHtml;
                    },
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            //
            doQueryHandler(queryModel){
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getMerchtGoodsUknoList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.checkedIniting = true;
                this.pageNumber = val;
                this.getMerchtGoodsUknoList();
            },
            getMerchtGoodsUknoList: function () {
                let self = this;
                let postData = {};
                //
                let queryModel = self.queryModel;
                let filterItems = queryModel.filterItems;
                if(!Utils.isNoB(self.itemId) || !Utils.isNoB(self.voucherId)) {
                    filterItems.shipVoucherItemId = self.itemId;
                    filterItems.shipVoucherId = self.voucherId;
                }
                postData.filterItems = Utils.merge({}, filterItems);
                postData.sortItemList = Utils.merge([], queryModel.sortItemList);
                postData.sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let theLoad = MsgBox.loading();
                goodsDelivApi.getMerchtGoodsUknoListByFilter(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let merchtGoodsUknoList = result.data;
                        self.renderTable(merchtGoodsUknoList, null);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>






// WEBPACK FOOTER //
// src/compo/order/MerchtGoodsUknoList.vue